package br.com.texeratx.boardgametimeapp.ui.screens.signup

data class SignupUiState(
    val displayName: String = "",
    val email: String = "",
    val password: String = "",
    val confirmPassword: String = "",
    val isLoading: Boolean = false,
    val error: String? = null
)
